import { api, buildUrl } from './api.service';

/**
 * Returns the absolute url of the captcha image. A query parameter is appended
 * to bust the browser cache and force a fresh captcha on every reload.
 */
export function captchaImageUrl(): string {
  return buildUrl(`/api/module/ums/reset-password/captcha?t=${Date.now()}`);
}

/**
 * Triggers the reset-password mail flow.
 */
export async function requestPasswordReset(
  email: string,
  captcha: string,
  locale: string = 'de_DE'
): Promise<void> {
  await api('/api/module/ums/reset-password/init', {
    method: 'POST',
    body: { email, captcha, locale },
    anonymous: true
  });
}

/**
 * Validates a reset token (from the deep link).
 */
export async function validateResetToken(token: string): Promise<boolean> {
  try {
    const response = await api<{success: boolean; valid: boolean}>(
      `/api/module/ums/reset-password/token/validate/${encodeURIComponent(token)}`,
      { anonymous: true }
    );
    return !!response.valid;
  } catch {
    return false;
  }
}

/**
 * Submits the new password using the reset token as authorization.
 *
 * The ums-server's authenticationGuard recognizes a reset token on
 * `PUT /user/:userId` requests and resolves it to the matching session
 * token internally, so this single call is enough to update the password.
 */
export async function setNewPassword(
  resetToken: string,
  userId: number,
  newPasswordHash: string
): Promise<void> {
  await api(`/api/module/ums/user/${userId}`, {
    method: 'PUT',
    body: { userId, password: newPasswordHash },
    anonymous: true,
    headers: { 'X-Api-Token': resetToken }
  });
}
